import React from "react";
import VerifyEmail from "../components/VerifyEmail/VerifyEmail";
import NothingThere from "../components/404/NothingThere";
import ResetPassword from "../components/ResetPassword/ResetPassword";
import DeleteAccount from "../components/DeleteAccount/DeleteAccount";

const queryString = require("query-string");

interface IState {
  mode: "verifyEmail" | "resetPassword" | "deleteAccount";
  oobCode: string;
}

export default class AuthController extends React.Component {
  state: Readonly<IState> = {
      mode: queryString.parse(window.location.search).mode,
      oobCode: queryString.parse(window.location.search).oobCode,
  };

  contentController() {
    console.log(this.state.mode);
    switch (this.state.mode) {
      case "verifyEmail":
        return <VerifyEmail oobCode={this.state.oobCode} />;
      case "resetPassword":
        return <ResetPassword oobCode={this.state.oobCode} />;
      case "deleteAccount":
        return <DeleteAccount oobCode={this.state.oobCode} />;
      default:
        return <NothingThere />;
    }
  }

  render() {
    return (
      <div
        className={"authContainer"}
        style={{ alignItems: "center", width: "100%" }}
      >
        {this.contentController()}
      </div>
    );
  }
}
